module.exports = __webpack_public_path__ + "img/规章制度.5a35a721.svg";